import React from 'react';
import { Square } from './features';
import styles from './App.module.css';

function App() {
  return (
    <main className={styles.main}>
      <Square />
    </main>
  );
}

export default App;
